import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import it from './locales/it.json';

const SUPPORTED_LANGUAGES = ['it', 'en'];

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
  name: 'customDetector',
  lookup() {
    // ?lang=en (e.g. coming from the English e-commerce) takes precedence
    // and gets persisted via cacheUserLanguage.
    const fromQuery = new URLSearchParams(window.location.search)
      .get('lang')
      ?.toLowerCase();
    if (fromQuery && SUPPORTED_LANGUAGES.includes(fromQuery)) return fromQuery;

    const stored = localStorage.getItem('i18nextLng');
    if (stored) return stored;
    return 'it';
  },
  cacheUserLanguage(lng: string) {
    localStorage.setItem('i18nextLng', lng);
  },
});

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      it: { translation: it },
    },
    fallbackLng: 'it',
    supportedLngs: SUPPORTED_LANGUAGES,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['customDetector'],
      caches: ['customDetector'],
    },
  });

// Keep <html lang> in sync with the active language so browsers don't
// mis-detect the content language and trigger auto-translation (which
// mutates the DOM under React and causes `removeChild` crashes).
const syncHtmlLang = (lng: string) => {
  document.documentElement.lang = lng.split('-')[0];
};
syncHtmlLang(i18n.language || 'it');
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
